import React from 'react'

const Footer = () => {
  return (
    <div>
        <div className='uparr'>
          <a href='#'>
            <i className="bi bi-arrow-up-circle text-warning"></i>
            </a>
        </div>
        <div className='footer'>© Copyright 2023 Likhith kumar</div>
    </div>
  )
}

export default Footer